import { ErrorMessage } from "@hookform/error-message";
import { Fragment, useEffect, useMemo, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { NumericFormat } from "react-number-format";
import { useHistory, useParams } from "react-router-dom/cjs/react-router-dom.min";
import { toast } from "react-toastify";
import { Button, Col, Row } from "reactstrap";
import { Block, BlockBetween, BlockHead, BlockHeadContent, BlockTitle, Icon } from "../../components/Component";
import { GET, POST } from "../../helper/api";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import { SETTING_KEY } from "../../utils/Utils";

const DEFAULT_BILL_EXTERNAL_CONTRACT_ESTIMATE = {
  numOfContainer: 0,
  billExternalContractId: null,
  deliveryFeePerContainer: {},
  exchangeRate: 0,
  shipFeeSealFeePerContainer: 0,
  shipFeeCustomFee: {},
  coFee: 0,
  baseFeeBankFee: 0,
  baseFeePackageFee: 0,
  baseFeeShipBuildingFee: 0,
  liftOnFee: 0,
  liftOffFee: 0,
  infrastructureFee: 0,
};

const BillExternalContractEstimate = () => {
  const history = useHistory();
  const [smOption, setSmOption] = useState(false);
  const [loading, setLoading] = useState(false);

  const [warehouseOptions, setWarehouseOptions] = useState([]);
  const [billExternalContract, setBillExternalContract] = useState(null)
  const params = useParams();
  const { id } = params;
  const methodForm = useForm({
    defaultValues: {
      ...DEFAULT_BILL_EXTERNAL_CONTRACT_ESTIMATE,
      billExternalContractId: id,
    },
    shouldFocusError: true,
  });

  const {
    reset,
    watch,
    getValues,
    control,
    setValue,
    register,
    errors,
    handleSubmit,
  } = methodForm;

  useEffect(() => {
    GET("/warehouse", {}, true).then((resp) => {
      setWarehouseOptions(
        resp.data?.rows?.map(
          (c) =>
          ({
            label: c.name,
            value: c.id,
            data: c,
          })
        )
      );
    });
  }, []);

  useEffect(() => {
    if (!id) {
      toast.error('Không tồn tại hợp đồng');
      history.goBack();
      return;
    }
    GET(`/bill-external-contract/${id}`, {}, true).then((resp) => {
      let { data: { billExternalContractEstimate, ...billExternalContract } } = resp;
      setBillExternalContract(billExternalContract);
    });

    GET(`/bill-external-contract/estimate/${id}`, {}, true).then((resp) => {
      let { data } = resp;
      if (data) {
        reset(data);
      } else {
        GET("/setting", {}, true).then(({ data }) => {
          const billExternalContractEstimate = {
            deliveryFeePerContainer: {},
            exchangeRate: 0,
            numOfContainer: 0,
            shipFeeSealFeePerContainer: 0,
            shipFeeCustomFee: {},
            coFee: 0,
            baseFeeBankFee: 0,
            baseFeePackageFee: 0,
            baseFeeShipBuildingFee: 0,
            infrastructureFee: 0,
            liftOffFee: 0,
            liftOnFee: 0
          };
          data.forEach(({ content, key }) => {
            // eslint-disable-next-line default-case
            switch (key) {
              case SETTING_KEY.DELIVERY_FEE_PER_CONTAINER:
                billExternalContractEstimate.deliveryFeePerContainer = content;
                break;
              case SETTING_KEY.SHIP_FEE_SEAL_FEE_PER_CONTAINER:
                billExternalContractEstimate.shipFeeSealFeePerContainer = Number(content);
                break;
              case SETTING_KEY.CO_FEE:
                billExternalContractEstimate.coFee = Number(content);
                break;
              case SETTING_KEY.BASE_FEE_BANK_FEE:
                billExternalContractEstimate.baseFeeBankFee = Number(content);
                break;
              case SETTING_KEY.BASE_FEE_PACKAGE_FEE:
                billExternalContractEstimate.baseFeePackageFee = Number(content);
                break;
              case SETTING_KEY.BASE_FEE_SHIP_BUILDING_FEE:
                billExternalContractEstimate.baseFeeShipBuildingFee = Number(content);
                break;
              case SETTING_KEY.INFARSTRUCTURE_FEE:
                billExternalContractEstimate.infrastructureFee = Number(content);
                break;
              case SETTING_KEY.LIFT_OFF_FEE:
                billExternalContractEstimate.liftOffFee = Number(content);
                break;
              case SETTING_KEY.SHIP_FEE_CUSTOM_FEE:
                billExternalContractEstimate.shipFeeCustomFee = content;
                break;
            }

          })
          reset(billExternalContractEstimate);
        })
      }
    });
  }, [id]);

  const deliveryFeePerContainer = watch('deliveryFeePerContainer');

  warehouseOptions.forEach(({ value: warehouseId }) => {
    deliveryFeePerContainer[warehouseId] = Number(deliveryFeePerContainer[warehouseId] || 0)
  })

  const exchangeRate = watch('exchangeRate');
  const numOfContainer = watch('numOfContainer');
  const shipFeeSealFeePerContainer = watch('shipFeeSealFeePerContainer');
  const shipFeeCustomFee = watch('shipFeeCustomFee');
  shipFeeCustomFee.firstContainer = Number(shipFeeCustomFee.firstContainer || 0)
  shipFeeCustomFee.restContainer = Number(shipFeeCustomFee.restContainer || 0)
  const coFee = watch('coFee');
  const baseFeeBankFee = watch('baseFeeBankFee');
  const baseFeePackageFee = watch('baseFeePackageFee');
  const baseFeeShipBuildingFee = watch('baseFeeShipBuildingFee');
  const infrastructureFee = watch('infrastructureFee');
  const liftOffFee = watch('liftOffFee');
  const liftOnFee = watch('liftOnFee');

  const netFee = useMemo(() => {
    const netFee = {}

    warehouseOptions.forEach(({ value: warehouseId }) => {

      netFee[warehouseId] = Number((
        deliveryFeePerContainer[warehouseId] / exchangeRate / 20000 +
        billExternalContract?.contractUnitPrice / 1000 * billExternalContract?.insuranceRate / 100 * Number((1 + (+billExternalContract?.insuranceTax || 0) / 100).toFixed(2)) +
        billExternalContract?.shipFeebillFee / billExternalContract?.contractQuantity / 1000 +
        shipFeeSealFeePerContainer / 20000 +
        (numOfContainer > 0 ? (shipFeeCustomFee.firstContainer + (numOfContainer - 1) * shipFeeCustomFee.restContainer) / billExternalContract?.contractQuantity / 1000 : 0) / exchangeRate +
        coFee / exchangeRate / 20000 +
        baseFeeBankFee / 20000 +
        baseFeePackageFee / 20000 +
        baseFeeShipBuildingFee / 20000 +
        billExternalContract?.baseFeeCommissionFeePerWeightRate / 1000 +
        billExternalContract?.shipFeeUnitPrice / 20000 +
        infrastructureFee / 20000 / exchangeRate +
        liftOffFee / 20000 / exchangeRate +
        liftOnFee / 20000 / exchangeRate
      )?.toFixed(4) || 0)
    })
    return netFee
  }, [
    billExternalContract,
    deliveryFeePerContainer,
    exchangeRate,
    numOfContainer,
    shipFeeCustomFee,
    shipFeeSealFeePerContainer,
    coFee,
    baseFeeBankFee,
    baseFeePackageFee,
    baseFeeShipBuildingFee,
    infrastructureFee,
    liftOffFee,
    liftOnFee,
    warehouseOptions,
  ])

  const onHandleSubmit = (data) => {

    Object.keys(data).forEach(key => {
      if (key === 'deliveryFeePerContainer') {
        Object.keys(data.deliveryFeePerContainer).forEach((k) => {
          data.deliveryFeePerContainer[k] = Number(data.deliveryFeePerContainer[k])
        })
      }
      else if (key === 'shipFeeCustomFee') {
        Object.keys(shipFeeCustomFee).forEach((k) => {
          data.shipFeeCustomFee[k] = Number(data.shipFeeCustomFee[k])
        })
      } else {
        data[key] = Number(data[key])
      }
    })

    setLoading(true);
    POST(`/bill-external-contract/bill-external-contract-estimate/${id}`, data, {}, true)
      .then((res) => {
        toast.success("Cập nhật thành công");
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };
  return (<Fragment>
    <Head title="Giá net hợp đồng xuất khẩu"></Head>

    <Content>
      <BlockHead size="sm">
        <BlockBetween>
          <BlockHeadContent>
            <BlockTitle page>Giá net hợp đồng xuất khẩu</BlockTitle>
          </BlockHeadContent>
          <BlockHeadContent>
            <div className="toggle-wrap nk-block-tools-toggle">
              <a
                href="#more"
                className="btn btn-icon btn-trigger toggle-expand mr-n1"
                onClick={(ev) => {
                  ev.preventDefault();
                  setSmOption(!smOption);
                }}
              >
                <Icon name="more-v"></Icon>
              </a>
              <div
                className="toggle-expand-content"
                style={{ display: smOption ? "block" : "none" }}
              >
                <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">
                  <li>
                    <div>
                      <Button
                        color="primary"
                        onClick={() => {
                          history.goBack();
                        }}
                      >
                        <span>Trở về</span>
                      </Button>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </BlockHeadContent>
        </BlockBetween>
      </BlockHead>
      <form onSubmit={handleSubmit(onHandleSubmit)}>

        <Block>
          <div className="card card-bordered card-preview">
            <div className="card-inner">
              <Row className="mt-3 g-2">
                <Col md="2">
                  <div className="form-group">
                    <label className="form-label" htmlFor="customer">
                      Tên hợp đồng
                    </label>
                    <div className="form-control-wrap">
                      {billExternalContract?.name}
                    </div>
                  </div>
                </Col>
                <Col md="2">
                  <div className="form-group">
                    <label className="form-label" htmlFor="customer">
                      Đơn giá bán($/tấn)
                    </label>
                    <div className="form-control-wrap">
                      <NumericFormat
                        value={Number(billExternalContract?.contractUnitPrice)}
                        displayType={"text"}
                        decimalScale={2}
                        thousandSeparator={","}
                        thousandsGroupStyle="thousand"
                      />
                    </div>
                  </div>
                </Col>
                <Col md="2">
                  <div className="form-group">
                    <label className="form-label" htmlFor="customer">
                      Tỉ lệ phí bảo hiểm(%)
                    </label>
                    <div className="form-control-wrap">
                      <NumericFormat
                        value={Number(billExternalContract?.insuranceRate)}
                        displayType={"text"}
                        decimalScale={2}
                        thousandSeparator={","}
                        thousandsGroupStyle="thousand"
                      />
                    </div>
                  </div>
                </Col>
                <Col md="2">
                  <div className="form-group">
                    <label className="form-label" htmlFor="customer">
                      Bill tàu/bộ($)
                    </label>
                    <div className="form-control-wrap">
                      <NumericFormat
                        value={Number(billExternalContract?.shipFeebillFee)}
                        displayType={"text"}
                        decimalScale={2}
                        thousandSeparator={","}
                        thousandsGroupStyle="thousand"
                      />
                    </div>
                  </div>
                </Col>
                <Col md="2">
                  <div className="form-group">
                    <label className="form-label" htmlFor="customer">
                      Hoa Hồng($/tấn)
                    </label>
                    <div className="form-control-wrap">
                      <NumericFormat
                        value={Number(billExternalContract?.baseFeeCommissionFeePerWeightRate)}
                        displayType={"text"}
                        decimalScale={2}
                        thousandSeparator={","}
                        thousandsGroupStyle="thousand"
                      />
                    </div>
                  </div>
                </Col>
                <Col md="2">
                  <div className="form-group">
                    <label className="form-label" htmlFor="customer">
                      Cước/cont($)
                    </label>
                    <div className="form-control-wrap">
                      <NumericFormat
                        value={Number(billExternalContract?.shipFeeUnitPrice)}
                        displayType={"text"}
                        decimalScale={2}
                        thousandSeparator={","}
                        thousandsGroupStyle="thousand"
                      />
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </Block>
        <Block>
          <div className="card card-bordered card-preview">
            <div className="card-inner">
              <div className="my-3">
                <Row className="mt-3 g-2">
                  <Col md="2">
                    <div className="form-group">
                      <label className="form-label" htmlFor="customer">
                        Số cont đóng <span className="text-danger">*</span>
                      </label>
                      <div className="form-control-wrap">
                        <Controller
                          control={control}
                          name="numOfContainer"
                          rules={{ required: "Vui lòng nhập thông tin" }}
                          render={({ onChange, value, ref }) => (
                            <NumericFormat
                              className="form-control"
                              getInputRef={ref}
                              type="text"
                              value={value}
                              thousandsGroupStyle="thousand"
                              thousandSeparator=","
                              decimalScale={0}
                              onValueChange={(val) => onChange(val.floatValue)}
                            />
                          )}
                        />

                        <ErrorMessage
                          errors={errors}
                          name="numOfContainer"
                          render={({ message }) => (
                            <span className="invalid">{message}</span>
                          )}
                        />
                      </div>
                    </div>
                  </Col>
                  {warehouseOptions.map(({ value, label }) =>
                    <Col md="2" key={value}>
                      <div className="form-group">
                        <label className="form-label" htmlFor="customer">
                          VC từ {label}(đ)<span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={control}
                            name={`deliveryFeePerContainer.${value}`}
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, ref }) => (
                              <NumericFormat
                                className="form-control"
                                getInputRef={ref}
                                type="text"
                                value={value}
                                thousandsGroupStyle="thousand"
                                thousandSeparator=","
                                decimalScale={0}
                                onValueChange={(val) => onChange(val.floatValue)}
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={errors}
                            name={`deliveryFeePerContainer.${value}`}
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>

                  )}
                  <Col md="2">
                    <div className="form-group">
                      <label className="form-label" htmlFor="customer">
                        Tỉ giá <span className="text-danger">*</span>
                      </label>
                      <div className="form-control-wrap">

                        <Controller
                          control={control}
                          name="exchangeRate"
                          rules={{ required: "Vui lòng nhập thông tin" }}
                          render={({ onChange, value, ref }) => (
                            <NumericFormat
                              className="form-control"
                              getInputRef={ref}
                              type="text"
                              value={value}
                              thousandsGroupStyle="thousand"
                              thousandSeparator=","
                              decimalScale={2}
                              onValueChange={(val) => onChange(val.floatValue)}
                            />
                          )}
                        />
                        <ErrorMessage
                          errors={errors}
                          name="exchangeRate"
                          render={({ message }) => (
                            <span className="invalid">{message}</span>
                          )}
                        />
                      </div>
                    </div>
                  </Col>
                  <Col md="2">
                    <div className="form-group">
                      <label className="form-label" htmlFor="customer">
                        Seal/cont($) <span className="text-danger">*</span>
                      </label>
                      <div className="form-control-wrap">
                        <Controller
                          control={control}
                          name="shipFeeSealFeePerContainer"
                          rules={{ required: "Vui lòng nhập thông tin" }}
                          render={({ onChange, value, ref }) => (
                            <NumericFormat
                              className="form-control"
                              getInputRef={ref}
                              type="text"
                              value={value}
                              thousandsGroupStyle="thousand"
                              thousandSeparator=","
                              decimalScale={2}
                              onValueChange={(val) => onChange(val.floatValue)}
                            />
                          )}
                        />
                        <ErrorMessage
                          errors={errors}
                          name="shipFeeSealFeePerContainer"
                          render={({ message }) => (
                            <span className="invalid">{message}</span>
                          )}
                        />
                      </div>
                    </div>
                  </Col>
                  <Col md="2">
                    <div className="form-group">
                      <label className="form-label" htmlFor="customer">
                        DVHQ cont đầu(đ)<span className="text-danger">*</span>
                      </label>
                      <div className="form-control-wrap">

                        <Controller
                          control={control}
                          name="shipFeeCustomFee.firstContainer"
                          rules={{ required: "Vui lòng nhập thông tin" }}
                          render={({ onChange, value, ref }) => (
                            <NumericFormat
                              className="form-control"
                              getInputRef={ref}
                              type="text"
                              value={value}
                              thousandsGroupStyle="thousand"
                              thousandSeparator=","
                              decimalScale={0}
                              onValueChange={(val) => onChange(val.floatValue)}
                            />
                          )}
                        />
                        <ErrorMessage
                          errors={errors}
                          name="shipFeeCustomFee.firstContainer"
                          render={({ message }) => (
                            <span className="invalid">{message}</span>
                          )}
                        />
                      </div>
                    </div>
                  </Col>
                  <Col md="2">
                    <div className="form-group">
                      <label className="form-label" htmlFor="customer">
                        DVHQ cont còn lại(đ)<span className="text-danger">*</span>
                      </label>
                      <div className="form-control-wrap">
                        <Controller
                          control={control}
                          name="shipFeeCustomFee.restContainer"
                          rules={{ required: "Vui lòng nhập thông tin" }}
                          render={({ onChange, value, ref }) => (
                            <NumericFormat
                              className="form-control"
                              getInputRef={ref}
                              type="text"
                              value={value}
                              thousandsGroupStyle="thousand"
                              thousandSeparator=","
                              decimalScale={0}
                              onValueChange={(val) => onChange(val.floatValue)}
                            />
                          )}
                        />
                        <ErrorMessage
                          errors={errors}
                          name="shipFeeCustomFee.restContainer"
                          render={({ message }) => (
                            <span className="invalid">{message}</span>
                          )}
                        />
                      </div>
                    </div>
                  </Col>
                  <Col md="2">
                    <div className="form-group">
                      <label className="form-label" htmlFor="customer">
                        Phí CO(đ)<span className="text-danger">*</span>
                      </label>
                      <div className="form-control-wrap">
                        <Controller
                          control={control}
                          name="coFee"
                          rules={{ required: "Vui lòng nhập thông tin" }}
                          render={({ onChange, value, ref }) => (
                            <NumericFormat
                              className="form-control"
                              getInputRef={ref}
                              type="text"
                              value={value}
                              thousandsGroupStyle="thousand"
                              thousandSeparator=","
                              decimalScale={0}
                              onValueChange={(val) => onChange(val.floatValue)}
                            />
                          )}
                        />
                        <ErrorMessage
                          errors={errors}
                          name="coFee"
                          render={({ message }) => (
                            <span className="invalid">{message}</span>
                          )}
                        />
                      </div>
                    </div>
                  </Col>
                  <Col md="2">
                    <div className="form-group">
                      <label className="form-label" htmlFor="customer">
                        Phí ngân hàng/cont($)<span className="text-danger">*</span>
                      </label>
                      <div className="form-control-wrap">
                        <Controller
                          control={control}
                          name="baseFeeBankFee"
                          rules={{ required: "Vui lòng nhập thông tin" }}
                          render={({ onChange, value, ref }) => (
                            <NumericFormat
                              className="form-control"
                              getInputRef={ref}
                              type="text"
                              value={value}
                              thousandsGroupStyle="thousand"
                              thousandSeparator=","
                              decimalScale={2}
                              onValueChange={(val) => onChange(val.floatValue)}
                            />
                          )}
                        />
                        <ErrorMessage
                          errors={errors}
                          name="baseFeeBankFee"
                          render={({ message }) => (
                            <span className="invalid">{message}</span>
                          )}
                        />
                      </div>
                    </div>
                  </Col>
                  <Col md="2">
                    <div className="form-group">
                      <label className="form-label" htmlFor="customer">
                        Phí túi/cont($)<span className="text-danger">*</span>
                      </label>
                      <div className="form-control-wrap">
                        <Controller
                          control={control}
                          name="baseFeePackageFee"
                          rules={{ required: "Vui lòng nhập thông tin" }}
                          render={({ onChange, value, ref }) => (
                            <NumericFormat
                              className="form-control"
                              getInputRef={ref}
                              type="text"
                              value={value}
                              thousandsGroupStyle="thousand"
                              thousandSeparator=","
                              decimalScale={2}
                              onValueChange={(val) => onChange(val.floatValue)}
                            />
                          )}
                        />
                        <ErrorMessage
                          errors={errors}
                          name="baseFeePackageFee"
                          render={({ message }) => (
                            <span className="invalid">{message}</span>
                          )}
                        />
                      </div>
                    </div>
                  </Col>
                  <Col md="2">
                    <div className="form-group">
                      <label className="form-label" htmlFor="customer">
                        Công đóng/cont($)<span className="text-danger">*</span>
                      </label>
                      <div className="form-control-wrap">
                        <Controller
                          control={control}
                          name="baseFeeShipBuildingFee"
                          rules={{ required: "Vui lòng nhập thông tin" }}
                          render={({ onChange, value, ref }) => (
                            <NumericFormat
                              className="form-control"
                              getInputRef={ref}
                              type="text"
                              value={value}
                              thousandsGroupStyle="thousand"
                              thousandSeparator=","
                              decimalScale={2}
                              onValueChange={(val) => onChange(val.floatValue)}
                            />
                          )}
                        />
                        <ErrorMessage
                          errors={errors}
                          name="baseFeeShipBuildingFee"
                          render={({ message }) => (
                            <span className="invalid">{message}</span>
                          )}
                        />
                      </div>
                    </div>
                  </Col>
                  <Col md="2">
                    <div className="form-group">
                      <label className="form-label" htmlFor="customer">
                        Phí CSHT(đ)<span className="text-danger">*</span>
                      </label>
                      <div className="form-control-wrap">
                        <Controller
                          control={control}
                          name="infrastructureFee"
                          rules={{ required: "Vui lòng nhập thông tin" }}
                          render={({ onChange, value, ref }) => (
                            <NumericFormat
                              className="form-control"
                              getInputRef={ref}
                              type="text"
                              value={value}
                              thousandsGroupStyle="thousand"
                              thousandSeparator=","
                              decimalScale={0}
                              onValueChange={(val) => onChange(val.floatValue)}
                            />
                          )}
                        />
                        <ErrorMessage
                          errors={errors}
                          name="infrastructureFee"
                          render={({ message }) => (
                            <span className="invalid">{message}</span>
                          )}
                        />
                      </div>
                    </div>
                  </Col>
                  <Col md="2">
                    <div className="form-group">
                      <label className="form-label" htmlFor="customer">
                        Phí nâng(đ)<span className="text-danger">*</span>
                      </label>
                      <div className="form-control-wrap">
                        <Controller
                          control={control}
                          name="liftOnFee"
                          rules={{ required: "Vui lòng nhập thông tin" }}
                          render={({ onChange, value, ref }) => (
                            <NumericFormat
                              className="form-control"
                              getInputRef={ref}
                              type="text"
                              value={value}
                              thousandsGroupStyle="thousand"
                              thousandSeparator=","
                              decimalScale={0}
                              onValueChange={(val) => onChange(val.floatValue)}
                            />
                          )}
                        />
                        <ErrorMessage
                          errors={errors}
                          name="liftOnFee"
                          render={({ message }) => (
                            <span className="invalid">{message}</span>
                          )}
                        />
                      </div>
                    </div>
                  </Col>
                  <Col md="2">
                    <div className="form-group">
                      <label className="form-label" htmlFor="customer">
                        Phí hạ(đ)<span className="text-danger">*</span>
                      </label>
                      <div className="form-control-wrap">
                        <Controller
                          control={control}
                          name="liftOffFee"
                          rules={{ required: "Vui lòng nhập thông tin" }}
                          render={({ onChange, value, ref }) => (
                            <NumericFormat
                              className="form-control"
                              getInputRef={ref}
                              type="text"
                              value={value}
                              thousandsGroupStyle="thousand"
                              thousandSeparator=","
                              decimalScale={0}
                              onValueChange={(val) => onChange(val.floatValue)}
                            />
                          )}
                        />
                        <ErrorMessage
                          errors={errors}
                          name="liftOffFee"
                          render={({ message }) => (
                            <span className="invalid">{message}</span>
                          )}
                        />
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </Block>

        <Block>
          <div className="card card-bordered card-preview">
            <div className="card-inner">
              <div className="my-3">
                <Row className="mt-3 g-2">
                  {warehouseOptions.map(({ value, label }) =>
                    <Col md="4" key={value}>
                      <div className="form-group">
                        <label className="form-label" htmlFor="customer">
                          Giá net /kg {label}
                        </label>
                        <div className="form-control-wrap">
                          <NumericFormat
                            value={Number(netFee?.[value])}
                            displayType={"text"}
                            decimalScale={4}
                            thousandSeparator={","}
                            thousandsGroupStyle="thousand"
                            prefix="$"
                          /> ~ <NumericFormat
                            value={Math.round(netFee?.[value] * exchangeRate)}
                            displayType={"text"}
                            decimalScale={0}
                            thousandSeparator={","}
                            thousandsGroupStyle="thousand"
                            suffix="đ"
                          />
                        </div>
                      </div>
                    </Col>
                  )}
                </Row>
              </div>
            </div>
          </div>
        </Block>
        <Block>
          <Button disabled={loading}>Lưu</Button>
        </Block>
      </form>

    </Content>
  </Fragment>)
}

export default BillExternalContractEstimate;